import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Container from '@mui/material/Container';
import { i18n_seo_meditations_guided_meditations } from '@yi/i18n/phrases/i18n_seo_meditations_guided_meditations';
import { i18n_seo_meditations_guided_relaxations } from '@yi/i18n/phrases/i18n_seo_meditations_guided_relaxations';
import { i18n_seo_meditations_intro } from '@yi/i18n/phrases/i18n_seo_meditations_intro';
import { i18n_seo_meditations_learn_to_meditate } from '@yi/i18n/phrases/i18n_seo_meditations_learn_to_meditate';
import { i18n_seo_meditations_members_get } from '@yi/i18n/phrases/i18n_seo_meditations_members_get';
import { i18n_seo_meditations_pranayama } from '@yi/i18n/phrases/i18n_seo_meditations_pranayama';
import { i18n_seo_meditations_yoga_nidra } from '@yi/i18n/phrases/i18n_seo_meditations_yoga_nidra';

import { pinkishOrange } from '~/styles';

import { BlockText } from '../FinderPage';
import { useLocale } from '../LocaleProvider';

// i18n text contains links needing styles
const LinkStylesWrapper = styled.div`
  & a {
    color: ${pinkishOrange};
  }
`;

export const SEOText: React.FC<PropsWithChildren> = () => {
  const { locale } = useLocale();
  return (
    <Container maxWidth="xl">
      <BlockText>
        <LinkStylesWrapper>
          <h1>{i18n_seo_meditations_learn_to_meditate(locale)}</h1>
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_intro(locale),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_guided_meditations(locale),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_yoga_nidra(locale),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_guided_relaxations(locale),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_pranayama(locale),
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: i18n_seo_meditations_members_get(locale),
            }}
          />
        </LinkStylesWrapper>
      </BlockText>
    </Container>
  );
};
